import getAuthorDetails from '~/utils/get-author-details'

export const homepageSchema = (includes, embeddedEeveeEntityIds) => {
  const author = getAuthorDetails(includes, embeddedEeveeEntityIds)

  return JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'WebPage',
    name: 'Uswitch Broadband Homepage',
    author: {
      '@type': 'Person',
      ...author
    }
  })
}
